import axios from 'axios'
import { API_URL } from './Cnx'

const REQUEST_URL = 'api/modulos'

export const getModulos = q =>
  axios.get(`${API_URL}/${REQUEST_URL}/`, { params: q })
